'use client';

import { CustomLink } from './CustomLink';
import NavbarCartButton from './NavbarCartButton';
import { SVG } from './SVG';

interface PCHeaderRightButtonsProps {
  isCartPage?: boolean;
  hasSubscriptions?: boolean;
}

const PCHeaderRightButtons = ({
  isCartPage,
  hasSubscriptions,
}: PCHeaderRightButtonsProps) => {
  return (
    <div className="flex items-center gap-[8px]">
      {hasSubscriptions && (
        <CustomLink
          href="/"
          className="flex items-center justify-center gap-[4px] rounded-[10px] bg-soil-brown-100 px-[8px] py-[4px]"
        >
          <SVG.Clock className="h-[24px] w-[24px] shrink-0 stroke-gray-600" />
          <p className="shrink-0 text-center text-[14px] font-medium text-gray-600">
            내 정기배송
          </p>
        </CustomLink>
      )}
      {!isCartPage && <NavbarCartButton size={24} strokeWidth={1.5} />}
      <CustomLink href="/mypages" className="shrink-0">
        <SVG.MyPage className="stroke-gray-700" strokeWidth={1.5} />
      </CustomLink>
    </div>
  );
};

export default PCHeaderRightButtons;
